export default "__VITE_ASSET__CRVtcMR2__"